// ✅ OPTIMIZACIÓN 2.1: Sistema de preloading inteligente para rutas probables
import { useEffect } from 'react';

/**
 * Preload de rutas basado en probabilidad de navegación
 * Ejemplo: Si estás en HomePage, es probable que vayas a ItemsPage
 */

// Rutas y sus preloads probables
const PRELOAD_MAP = {
  '/': ['/items', '/item'], // Desde HomePage, probablemente irás a ItemsPage o ItemDetailPage
  '/items': ['/item'], // Desde ItemsPage, probablemente verás un item
  '/item': ['/items'], // Desde ItemDetailPage, probablemente volverás a ItemsPage
  '/perfil': ['/cuenta', '/bookings'], // Desde ProfilePage, probablemente irás a AccountPage o Bookings
};

/**
 * Preload de un módulo específico
 */
export const preloadRoute = (routePath) => {
  // Mapeo de rutas a sus componentes lazy
  const routeToComponent = {
    '/items': () => import('../pages/ItemsPage'),
    '/item': () => import('../pages/ItemDetailPage'),
    '/perfil': () => import('../pages/ProfilePage'),
    '/cuenta': () => import('../pages/AccountPage'),
    '/bookings': () => import('../pages/UserBookings'),
    '/publicar': () => import('../pages/CreateItemPage'),
    '/search': () => import('../pages/SearchResultsPage'),
  };

  const preloadFn = routeToComponent[routePath];
  if (preloadFn) {
    preloadFn().catch(err => {
      console.warn(`[Preload] Error preloading ${routePath}:`, err);
    });
  }
};

/**
 * Preload de rutas probables basado en la ruta actual
 */
export const preloadProbableRoutes = (currentPath) => {
  const probableRoutes = PRELOAD_MAP[currentPath] || [];
  
  probableRoutes.forEach(route => {
    // Preload después de un pequeño delay para no bloquear la UI
    setTimeout(() => {
      preloadRoute(route);
    }, 100);
  });
};

/**
 * Preload de componentes pesados (Google Maps, MercadoPago)
 * Solo prepara los scripts, no los carga hasta que se necesiten
 */
export const preloadHeavyComponents = () => {
  // Los componentes pesados se cargan bajo demanda cuando se necesitan
  // Este método puede usarse para prefetch de recursos críticos en el futuro
  console.log('[Preload] Componentes pesados se cargarán bajo demanda');
};

/**
 * Hook para usar preloading en componentes
 */
export const usePreload = (currentPath) => {
  useEffect(() => {
    // Preload de rutas probables
    preloadProbableRoutes(currentPath);
    
    // Preload de componentes pesados después de que la página esté cargada
    if (document.readyState === 'complete') {
      setTimeout(preloadHeavyComponents, 2000); // Esperar 2 segundos después de carga completa
    } else {
      window.addEventListener('load', () => {
        setTimeout(preloadHeavyComponents, 2000);
      });
    }
  }, [currentPath]);
};

